<template>
  <div class="product-attribute">
    <div class="productsCont">
      <div class="productsTit padding-10">
        <div>商品属性</div>
      </div>
      <div class="products-content attrForm" style="padding:0 20px;">
        <Tabs v-model="activeTab" @on-click="handleTabChange">
          <!-- 经典属性 -->
          <TabPane label="经典属性" name="classic">
            <Form
              ref="classicAttributeForm"
              :model="attributeFom"
              :label-width="110"
              label-position="right"
            >
              <Row>
                <Col
                  v-for="(attr, aIndex) in (attributeFom.attributeValueQOList || [])"
                  :key="`attr-${aIndex}`"
                >
                  <FormItem
                    :label="`${attr.aliasName || ''}：`"
                    :label-width="240"
                    :prop="`attributeValueQOList.${aIndex}.attributeValueIdList`"
                    :class="{ 'important-attribute': [2, '2'].includes(attr.isMandatory) }"
                    :rules="[
                      { required: attr.isMandatory == 1, message: '必填项不能为空', trigger: 'blur', type: attr.type == 1 ? 'array' : 'number' },
                      { required: attr.isMandatory == 1, message: '必填项不能为空', trigger: 'change', type: attr.type == 1 ? 'array' : 'number' }
                    ]"
                  >
                    <dyt-select
                      clearable
                      v-model="attr.attributeValueIdList"
                      :multiple="attr.type == 1"
                      style="width: 280px;"
                      :disabled="isDisabled"
                      filterable
                    >
                      <Option
                        v-for="(attrVal, vIndex) in attr.valueVOList"
                        :value="attrVal.attributeValueId"
                        :key="`attrVal-${vIndex}`"
                      >
                        {{ `${attrVal.cnValue}:${attrVal.enValue}` }}
                      </Option>
                    </dyt-select>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </TabPane>

          <!-- 多平台商品属性 -->
          <TabPane label="多平台商品属性" name="multiPlatform">
            <div class="ai-attribute-content">
              <!-- 多平台商品属性展示与填写区 -->
              <div v-if="aiForm.attributeList.length > 0" class="ai-section">
                <div class="ai-section-header">
                  <!-- <div class="ai-section-title">商品属性</div> -->
                  <div>
                    <Button type="default" class="ai-input-btn" v-if="!isDisabled" @click="handleOpenAiInput">
                      <Icon type="ios-flash" size="16" />AI录入
                    </Button>
                  </div>
                  <span class="ai-required-tips">
                    <span class="required-star">*</span> 为必填项
                  </span>
                </div>

                <!-- 属性输入表单 -->
                <Form
                  ref="aiAttributeForm"
                  :model="aiForm.attributeValues"
                  :label-width="140"
                  label-position="right"
                  class="ai-attribute-form"
                >
                  <Row :gutter="20">
                    <Col
                      v-for="(attr, aIndex) in aiForm.attributeList"
                      :key="`ai-attr-${aIndex}`"
                      :span="12"
                    >
                      <FormItem
                        :label="`${attr.label}：`"
                        :prop="`${attr.field}`"
                        :rules="attr.required ? [
                          { required: true, message: `${attr.label}不能为空`, trigger: 'blur' },
                          { required: true, message: `${attr.label}不能为空`, trigger: 'change' }
                        ] : []"
                      >
                        <!-- 输入框 -->
                        <dyt-input
                          v-if="attr.type === 'input'"
                          v-model="aiForm.attributeValues[attr.field]"
                          :placeholder="attr.placeholder || `请输入${attr.label}`"
                          :disabled="isDisabled"
                          clearable
                        />
                        <!-- 多行文本 -->
                        <dyt-input
                          v-else-if="attr.type === 'textarea'"
                          v-model="aiForm.attributeValues[attr.field]"
                          type="textarea"
                          :rows="3"
                          :placeholder="attr.placeholder || `请输入${attr.label}`"
                          :disabled="isDisabled"
                        />
                        <!-- 下拉框 -->
                        <dyt-select
                          v-else-if="attr.type === 'select'"
                          v-model="aiForm.attributeValues[attr.field]"
                          :placeholder="attr.placeholder || `请选择${attr.label}`"
                          :disabled="isDisabled"
                          clearable
                        >
                          <Option
                            v-for="(option, oIndex) in (attr.options || [])"
                            :value="option.value"
                            :key="`ai-attr-opt-${aIndex}-${oIndex}`"
                          >
                            {{ option.label }}
                          </Option>
                        </dyt-select>
                        <!-- 默认兜底为输入框 -->
                        <dyt-input
                          v-else
                          v-model="aiForm.attributeValues[attr.field]"
                          :placeholder="attr.placeholder || `请输入${attr.label}`"
                          :disabled="isDisabled"
                          clearable
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>

    <!-- AI 长文本自动录入弹框 -->
    <Modal
      v-model="aiInputVisible"
      title="AI 长文本自动录入"
      width="600"
      :mask-closable="false"
      :closable="!aiParseLoading"
      :footer-hide="true"
    >
      <div class="ai-modal-content">
        <div class="ai-input-label">
          请输入或粘贴商品文本/描述信息：
        </div>
        <Input
          v-model="aiForm.aiInputText"
          type="textarea"
          :rows="6"
          placeholder="例如：品牌LAPA，人体工学电脑桌面滑轨托架，冷轧钢材质，黑色，尺寸65cm x 25cm，重量1.8kg，原产地中国，现代简约风格..."
        />
        <div class="ai-input-actions">
          <Button @click="handleCancelAiInput" :disabled="aiParseLoading">取消</Button>
          <Button
            type="primary"
            :loading="aiParseLoading"
            @click="handleParseAiText"
          >
            解析并自动填入
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'productAttribute',
  props: {
    // 商品信息
    productInfo: {
      type: Object,
      default: () => ({})
    },
    // 是否禁用
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 当前激活的 Tab
      activeTab: 'classic',
      // 经典属性数据
      attributeFom: {
        attributeValueQOList: [],
        productCategoryId: '',
        productId: ''
      },
      // 多平台商品属性表单数据
      aiForm: {
        // 属性字段列表
        attributeList: [],
        // 属性值
        attributeValues: {},
        // AI 录入文本
        aiInputText: ''
      },
      // AI 录入面板显示状态
      aiInputVisible: false,
      // AI 解析 loading
      aiParseLoading: false,
      // 多平台商品属性 id 映射（保存时回传）
      productPlatformAttributeIdMap: {},
      // 上一次商品分类 ID，用于判断是否为切换分类
      oldProductCategoryId: null,
      // 是否为首次加载属性（初始加载时尝试回显，切换分类时清空）
      isFirstAttributeLoad: true,
      // 是否为初始加载（初始加载先查商品属性，之后分类变化直接查分类属性）
      isInitialLoad: true
    };
  },
  watch: {
    // 监听商品分类变化，重新获取经典属性和多平台商品属性
    'productInfo.productCategoryId': {
      handler (newVal, oldVal) {
        if (newVal === oldVal) return;
        // console.log('productCategoryIdnewVal', newVal);
        // console.log('productCategoryIdoldVal', oldVal);
        // console.log('isInitialLoad', this.isInitialLoad);
        this.handleCategoryChange();
        if(this.isInitialLoad) return;
        this.clearMultiPlatformAttribute();
        if(!newVal) return;
        // 分类切换，直接查新分类属性
        this.loadCategoryPlatformAttribute(newVal);
      }
    },
    // 监听商品 ID 变化（打开新产品时重置首次加载标识）
    'productInfo.productId': {
      handler (newVal, oldVal) {
        // console.log('productId newVal', newVal);
        // console.log('productId oldVal', oldVal);
        if (newVal === oldVal) return;
        if(!newVal) {
          this.resetAttribute();
          return;
        }
        // // 商品 ID 发生变化时，重置为首次加载状态
        // if (newVal !== oldVal && oldVal !== undefined) {
        //   this.isFirstAttributeLoad = true;
        //   this.oldProductCategoryId = null;
        // }
        // 经典属性刷新
        this.handleCategoryChange();
        // this.clearMultiPlatformAttribute();
        this.initMultiPlatformAttribute().finally(() => {
          this.isInitialLoad = false;
        }) 
      }
    }
  },
  created () {
    // const info = this.productInfo || {};
    // this.oldProductCategoryId = info.productCategoryId || null;
    // this.isFirstAttributeLoad = true;
    // this.initClassicAttributeData(info);
    // this.initMultiPlatformAttribute();
  },
  methods: {
    // // 初始化经典属性数据
    // initClassicAttributeData (productInfo) {
    //   const info = productInfo || {};
    //   this.$set(this.attributeFom, 'productCategoryId', info.productCategoryId || '');
    //   this.$set(this.attributeFom, 'productId', info.productId || '');
    //   // 如果外部已经有属性数据，则同步（用于编辑回显）
    //   if (info.attributeFomNew && !this.$common.isEmpty(info.attributeFomNew.attributeValueQOList)) {
    //     this.$set(this.attributeFom, 'attributeValueQOList', info.attributeFomNew.attributeValueQOList);
    //   }
    // },
    // 处理商品分类变化（切换分类时清空已选值，初始化时尝试回显）
    handleCategoryChange () {
      const { productCategoryId, productId } = this.productInfo || {};
      // 同步 attributeFom 中的 ID，确保保存接口能拿到正确值
      this.$set(this.attributeFom, 'productCategoryId', productCategoryId || '');
      this.$set(this.attributeFom, 'productId', productId || '');
      if (!productCategoryId) {
        this.oldProductCategoryId = productCategoryId;
        this.$set(this.attributeFom, 'attributeValueQOList', []);
        this.resetClassicFields();
        return;
      }
      // 首次加载尝试回显已选值，后续切换分类清空已选值
      const categoryChange = !this.isFirstAttributeLoad && this.oldProductCategoryId !== productCategoryId;
      this.oldProductCategoryId = productCategoryId;
      this.isFirstAttributeLoad = false;
      this.getAttributeData({ productCategoryId, productId }, !categoryChange);
    },
    // 获取经典属性数据
    getAttributeData (attr, type = true) {
      this.getAttributeValueList(attr).then(res => {
        (res.attributeClassifyVOList || []).forEach(item => {
          // type 为 true 时尝试回显已选中的属性值
          if (type && res.attributeValueIds && res.attributeValueIds.length > 0) {
            if (item.type == 0) {
              const itemVal = (item.attributeValueList || []).filter(op => {
                return res.attributeValueIds.includes(op.attributeValueId);
              }).map(vItem => {
                return vItem.attributeValueId;
              });
              const val = itemVal.join('');
              item.attributeValueIdList = isNaN(val) ? val : val ? Number(val) : '';
            } else {
              item.attributeValueIdList = (item.attributeValueList || []).filter(op => {
                return res.attributeValueIds.includes(op.attributeValueId);
              }).map(vItem => {
                return vItem.attributeValueId;
              });
            }
          } else {
            item.attributeValueIdList = item.type == 0 ? '' : [];
          }
          item.valueVOList = item.attributeValueList;
        });
        this.$set(this.attributeFom, 'attributeValueQOList', res.attributeClassifyVOList || []);
      });
    }, 
    // 所属分类下拉（接口调用）
    getAttributeValueList (attr) {
      return new Promise(resolve => {
        this.axios.post(api.query_findAttribute, {
          productCategoryId: attr.productCategoryId,
          productId: attr.productId
        }).then(res => {
          if (res.data.code == 0) {
            resolve(res.data.datas || {});
            return;
          }
          resolve({});
        }).catch(() => {
          resolve({});
        });
      });
    },
    // 重置经典属性表单
    resetClassicFields () {
      this.$nextTick(() => {
        this.$refs['classicAttributeForm'] && this.$refs['classicAttributeForm'].resetFields();
      });
    },
    // 清空多平台属性（用户清除分类时调用）
    clearMultiPlatformAttribute () {
      this.$set(this.aiForm, 'attributeList', []);
      this.$set(this.aiForm, 'attributeValues', {});
      this.productPlatformAttributeIdMap = {};
    },
    // 重置整个属性模块（关闭弹窗时父组件调用）
    resetAttribute () {
      this.activeTab = 'classic';
      this.attributeFom = {
        attributeValueQOList: [],
        productCategoryId: '',
        productId: ''
      };
      this.oldProductCategoryId = null;
      this.isFirstAttributeLoad = true;
      this.isInitialLoad = true;
      this.aiForm = {
        attributeList: [],
        attributeValues: {},
        aiInputText: ''
      };
      this.productPlatformAttributeIdMap = {};
      this.aiInputVisible = false;
      this.resetClassicFields();
      // console.log('重置', this.isInitialLoad)
    },
    // Tab 切换
    handleTabChange (name) {
      this.activeTab = name;
    },
    // 设置 AI 属性列表
    setAiAttributeList (attributeList, keepValues = false) {
      const values = keepValues ? { ...this.aiForm.attributeValues } : {};
      attributeList.forEach(attr => {
        if (!keepValues || !values.hasOwnProperty(attr.field)) {
          values[attr.field] = attr.defaultValue || '';
        }
      });
      this.$set(this.aiForm, 'attributeList', attributeList);
      this.$set(this.aiForm, 'attributeValues', values);
    },
    // 统一归一化属性列表（兼容接口 schema 和 example 两种返回结构）
    normalizeAttributeList (rawList) {
      if (!Array.isArray(rawList) || rawList.length === 0) return [];
      const result = [];
      rawList.forEach(item => {
        // 兼容嵌套结构：接口 example 中的 platformCategoryAttributeVOList
        const nestedList = item.platformCategoryAttributeVOList;
        if (Array.isArray(nestedList) && nestedList.length > 0) {
          nestedList.forEach(nested => {
            result.push({
              id: nested.id,
              paramKey: nested.attributeName || nested.paramKey,
              paramValue: nested.paramValue || '',
              isRequired: nested.isRequired
            });
          });
          return;
        }
        // 扁平结构：接口 schema 中的标准属性
        if (item.paramKey || item.attributeName) {
          result.push({
            id: item.id,
            paramKey: item.paramKey || item.attributeName,
            paramValue: item.paramValue || '',
            isRequired: item.isRequired
          });
        }
      });
      // 必填项排序
      result.sort((a, b) => {
        if (a.isRequired && !b.isRequired) return -1;
        if (!a.isRequired && b.isRequired) return 1;
        return 0;
      });
      return result;
    },
    // 初始化多平台商品属性：优先查商品属性，无则查分类属性
    async initMultiPlatformAttribute () {
      const { productId, productCategoryId } = this.productInfo || {};
      if (!productId && !productCategoryId) return;
      // 有商品 ID 时先查商品属性
      if (productId) {
        const hasData = await this.loadProductPlatformAttribute(productId);
        if (hasData) return;
      }
      // 无商品属性时 fallback 到分类属性
      if (productCategoryId) {
        await this.loadCategoryPlatformAttribute(productCategoryId);
      } 
    },
    // 获取商品属性
    async loadProductPlatformAttribute (productId) {
      try {
        const res = await this.axios.get(api.get_productPlatformAttribute, {
          params: { productId }
        });
        if (res.data.code !== 0) return false;
        const list = this.normalizeAttributeList(res.data.datas);
        if (!list.length) return false;
        this.buildAiFormFromList(list, true);
        return true;
      } catch (err) {
        console.error('[loadProductPlatformAttribute] 查询失败', err);
        return false;
      }
    },
    // 获取分类属性
    async loadCategoryPlatformAttribute (productCategoryId) {
      try {
        const res = await this.axios.get(api.get_categoryPlatformAttribute, {
          params: { productCategoryId }
        });
        if (res.data.code !== 0) return;
        const list = this.normalizeAttributeList(res.data.datas);
        this.buildAiFormFromList(list, false);
      } catch (err) {
        console.error('[loadCategoryPlatformAttribute] 查询失败', err);
      }
    },
    // 根据属性列表构建表单
    // keepValues=true: 来自商品属性接口，id 为商品属性记录主键，保存时需回传
    // keepValues=false: 来自分类属性接口，id 为分类属性主键，保存时不传
    buildAiFormFromList (list, keepValues) {
      const idMap = {};
      const attributeList = list.map((item, index) => {
        const field = `attr_${index}`;
        idMap[field] = keepValues ? (item.id || null) : null;
        return {
          field,
          label: item.paramKey,
          required: item.isRequired == 1,
          type: 'input',
          placeholder: `请输入${item.paramKey}`,
          defaultValue: item.paramValue
        };
      });
      this.productPlatformAttributeIdMap = idMap;
      this.setAiAttributeList(attributeList, keepValues);
    },
    // 打开 AI 录入面板
    handleOpenAiInput () {
      this.aiInputVisible = true;
    },
    // 取消 AI 录入
    handleCancelAiInput () {
      this.aiInputVisible = false;
      this.aiForm.aiInputText = '';
    },
    // AI 解析文本并填充属性
    async handleParseAiText () {
      const rawText = this.aiForm.aiInputText.trim();
      if (!rawText) {
        this.$Message.warning('请先输入需要解析的文本！');
        return;
      }
      const attributeList = this.aiForm.attributeList.map(attr => ({
        paramKey: attr.label,
        isRequired: attr.required ? 1 : 0
      }));
      if (!attributeList.length) {
        this.$Message.warning('当前没有可填充的属性！');
        return;
      }
      this.aiParseLoading = true;
      try {
        const res = await this.axios.post(api.aiFill_productPlatformAttribute, {
          productPlatformAttributeList: attributeList,
          msg: rawText
        });
        if (res.data.code !== 0) {
          this.$Message.error(res.data.message || 'AI 解析失败');
          return;
        }
        this.fillAiAttributeValues(res.data.datas);
        this.$Message.success('AI 属性解析并填入完成！');
        this.handleCancelAiInput();
      } catch (err) {
        console.error('[handleParseAiText] AI 解析失败', err);
        this.$Message.error('AI 解析失败');
      } finally {
        this.aiParseLoading = false;
      }
    },
    // 填充 AI 属性值
    fillAiAttributeValues (extractedList) {
      if (!Array.isArray(extractedList)) return;
      const attributeValues = { ...this.aiForm.attributeValues };
      const labelMap = {};
      extractedList.forEach(item => {
        if (item.paramKey && !this.$common.isEmpty(item.paramValue)) {
          labelMap[item.paramKey] = item.paramValue;
        }
      });
      this.aiForm.attributeList.forEach(attr => {
        if (labelMap.hasOwnProperty(attr.label)) {
          attributeValues[attr.field] = labelMap[attr.label];
        }
      });
      this.$set(this.aiForm, 'attributeValues', attributeValues);
    },
    // 校验表单（经典属性始终校验，多平台商品属性有数据时校验）
    async validate () {
      let classicValid = true;
      let aiValid = true;
      // 经典属性校验
      if (this.$refs['classicAttributeForm']) {
        classicValid = await new Promise((resolve, reject) => {
          this.$refs['classicAttributeForm'].validate((valid) => {
            resolve(valid);
          });
        });
      }
      // 多平台商品属性校验（有属性时才校验）
      if (this.aiForm.attributeList.length > 0 && this.$refs['aiAttributeForm']) {
        aiValid = await new Promise((resolve, reject) => {
          this.$refs['aiAttributeForm'].validate((valid) => {
            resolve(valid);
          });
        });
      }
      return classicValid && aiValid;
    },
    // 保存经典属性（父组件在商品保存成功后调用，与 savePlatformAttribute 同级）
    async saveClassicAttribute (productId) {
      if (this.isDisabled) return; // 详情模式禁止提交
      const id = productId || this.productInfo.productId;
      if (!id) return;
      const data = this.formatClassicAttributeData();
      data.productId = id;
      try {
        const res = await this.axios.post(api.insert_attributeSpu, data);
        if (res.data.code !== 0) {
          this.$Message.error(res.data.message || '经典属性保存失败');
        }
      } catch (err) {
        console.error('[saveClassicAttribute] 保存失败', err);
        this.$Message.error('经典属性保存失败');
      }
    },
    // 格式化经典属性数据
    formatClassicAttributeData () {
      const attributeFom = JSON.parse(JSON.stringify(this.attributeFom));
      const attributeValueQOList = attributeFom.attributeValueQOList.map(item => {
        return {
          attributeValueIdList: typeof item.attributeValueIdList === 'number' ? [item.attributeValueIdList] : item.attributeValueIdList
        };
      });
      attributeFom.attributeValueQOList = attributeValueQOList.filter(item => {
        return typeof item.attributeValueIdList === 'number' || (item.attributeValueIdList && item.attributeValueIdList.length > 0);
      });
      return attributeFom;
    },
    // 保存多平台商品属性（父组件在商品保存成功后调用）
    async savePlatformAttribute (productId) {
      if (this.isDisabled) return; // 详情模式禁止提交
      const id = productId || this.productInfo.productId;
      if (!id) return;
      const list = this.formatAiAttributeData(id);
      // if (!list.length) return;
      try {
        const res = await this.axios.post(api.save_productPlatformAttribute, list);
        if (res.data.code !== 0) {
          this.$Message.error(res.data.message || '保存多平台商品属性失败');
        }
      } catch (err) {
        console.error('[savePlatformAttribute] 保存失败', err);
        this.$Message.error('保存多平台商品属性失败');
      }
    },
    // 格式化多平台商品属性数据为保存接口所需结构
    formatAiAttributeData (productId) {
      const { attributeList, attributeValues } = this.aiForm;
      const id = productId || this.productInfo.productId || '';
      return attributeList.map(attr => {
        const field = attr.field;
        return {
          // id: this.productPlatformAttributeIdMap[field] || undefined,
          productId: id,
          paramKey: attr.label,
          paramValue: attributeValues[field] || '',
          isRequired: attr.required ? 1 : 0
        };
      });
    }
  }
};
</script>

<style lang="less" scoped>
.product-attribute {
  // 未选中的 Tab 内容不占空间，容器高度跟随当前选中 Tab
  // 用 height:0 + overflow:hidden 收起，避免 display:none 与 v-show 冲突
  :deep(.ivu-tabs-tabpane[style*="visibility: hidden"]) {
    height: 0 !important;
    overflow: hidden !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  :deep(.important-attribute) {
    .ivu-form-item-label {
      color: #f20;
      font-weight: bold;
    }
  }
  .ai-attribute-content {
    .ai-section {
      margin-bottom: 16px;
    }
    .ai-section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e8e8e8;
      padding-bottom: 12px;
      margin-bottom: 16px;
      .ai-input-btn {
        margin-right: auto;
        background-color: rgba(150, 20, 150, 0.1);
        color: #9c27b0;
        border-color: #a447b4;
        i {
          margin-right: 4px;
          color: #9c27b0;
          font-weight: bold;
        }
      }
      .ai-required-tips {
        font-size: 12px;
        color: #ed4014;
        .required-star {
          color: #ed4014;
        }
      }
    }
    .ai-attribute-form {
      .ivu-form-item {
        padding-right: 20px;
      }
    }
  }
}

// AI 长文本自动录入弹框
.ai-modal-content {
  padding: 8px 0;
  .ai-input-label {
    font-size: 13px;
    color: #333;
    margin-bottom: 12px;
  }
  .ai-input-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }
}
</style>
